import {Trans} from "@lingui/react/macro";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";
import {toCanonicalUrl} from "@repo/urls";

const MODERATION_SUPPORT_DOC =
    "https://support.khanacademy.org/hc/articles/13871273505933-Why-was-my-Khanmigo-conversation-flagged";
const COMMUNITY_GUIDELINES = toCanonicalUrl("/r/khanmigo-moderation");

type FlaggedAnswerTextProps = {
    // Optional prop, because we're waiting on the backend implementation
    // so that we can wire this in the chat history view.  Also, we use this component in
    // the Writing Coach, which doesn't support image input yet.
    hasImage?: boolean;
};

/**
 * The text to display when an answer is flagged for moderation.
 */
export const FlaggedAnswerText = ({
    hasImage,
}: FlaggedAnswerTextProps): React.ReactElement => {
    if (!hasImage) {
        return (
            <Trans>
                This conversation has triggered Khanmigo's{" "}
                <Link href={MODERATION_SUPPORT_DOC}>moderation system</Link>. If
                you feel like this conversation follows the{" "}
                <Link href={COMMUNITY_GUIDELINES}>Community Guidelines</Link>,
                reword your response and try again. If you think it was flagged
                in error, click Leave Feedback to let us know.
            </Trans>
        );
    }

    return (
        <Trans>
            The image or text you submitted has triggered Khanmigo's{" "}
            <Link href={MODERATION_SUPPORT_DOC}>moderation system</Link>. Please
            change your response and try again, making sure it follows our{" "}
            <Link href={COMMUNITY_GUIDELINES}>Community Guidelines</Link>. If
            you think it was flagged in error, click Leave Feedback to let us
            know.
        </Trans>
    );
};
